export default __webpack_public_path__ + "static/media/place-type-unloading.86b8de7d.svg";